import React, { useContext, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaAngleRight } from 'react-icons/fa';
import '../css/typebar.css';

const TypeBar = observer(() => {
  const { detail } = useContext(Context);
  const [openTypeId, setOpenTypeId] = useState(null);
  const timeoutRef = useRef(null); // Store timeout for hiding subtypes

  const handleTypeClick = (type) => {
    if (detail.selectedType.id === type.id) {
      detail.setSelectedType({});
      detail.setSelectedSubType({});
      setOpenTypeId(null);
    } else {
      detail.setSelectedType(type);
      detail.setSelectedSubType({});
      setOpenTypeId(type.id);
    }
  };

  const handleSubTypeClick = (subType) => {
    if (detail.selectedSubType.id === subType.id) {
      detail.setSelectedSubType({});
    } else {
      detail.setSelectedType({ id: subType.typeId });
      detail.setSelectedSubType(subType);
    }
    setOpenTypeId(null); // Close subtypes after selection
  };

  const handleMouseEnterType = (typeId) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current); // Cancel any pending hide
    }
    setOpenTypeId(typeId);
  };

  const handleMouseLeaveType = () => {
    // Delay hiding the subtype list
    timeoutRef.current = setTimeout(() => {
      setOpenTypeId(null);
    }, 300); // 300ms delay
  };

  const handleMouseEnterSubType = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current); // Keep subtypes open when hovering over them
    }
  };

  const handleMouseLeaveSubType = () => {
    // Hide subtypes after leaving the subtype list
    timeoutRef.current = setTimeout(() => {
      setOpenTypeId(null);
    }, 300);
  };

  return (
    <div className="type-bar-container">
      <h3 className="type-bar-title">Категории</h3>
      <ListGroup>
        {detail.types.map((type) => (
          <div key={type.id} className="type-bar-item-wrapper">
            <ListGroup.Item
              active={type.id === detail.selectedType.id}
              onClick={() => handleTypeClick(type)}
              onMouseEnter={() => handleMouseEnterType(type.id)}
              onMouseLeave={handleMouseLeaveType}
              className={`type-bar-item ${type.id === detail.selectedType.id ? 'active' : ''}`}
            >
              <span className="type-name">{type.name}</span>
              <FaAngleRight className="type-icon" />
            </ListGroup.Item>
            {openTypeId === type.id && type.subTypes?.length > 0 && (
              <ListGroup
                className="sub-type-list"
                onMouseEnter={handleMouseEnterSubType}
                onMouseLeave={handleMouseLeaveSubType}
              >
                {type.subTypes.map((subType) => (
                  <ListGroup.Item
                    key={subType.id}
                    active={subType.id === detail.selectedSubType.id}
                    onClick={() => handleSubTypeClick(subType)}
                    className={`sub-type-item ${
                      subType.id === detail.selectedSubType.id ? 'active' : ''
                    }`}
                  >
                    {subType.name}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </div>
        ))}
      </ListGroup>
    </div>
  );
});

export default TypeBar;